export default {"src":"/_next/static/media/MandatoryField.787d81fd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};